/**
 * The conversation a composer lives in, scrolled to its very end — the
 * nearest scrolling ancestor (the Builder's reply box sits inside its
 * conversation's scroller). Nothing to do where the box is outside one.
 * Its own module so a test can run it without loading the whole composer.
 */
export function scrollConversationToEnd(from: Element | null): void {
  const scroller = from?.closest('.overflow-y-auto');
  if (scroller) scroller.scrollTop = scroller.scrollHeight;
}
